(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cg-terminal-locator"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cg-terminal-locator')) {
  class CGTerminalLocator extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.copy = JSON.parse(this.querySelector('[data-copy]').textContent);
      this.zipUrls = JSON.parse(this.querySelector('[data-zip-urls]').textContent);
      this.shardPromises = new Map();
      this.form = this.querySelector('form');
      this.input = this.form.elements.zip;
      this.submit = this.form.querySelector('button');
      this.status = this.querySelector('.cg-tl-status');
      this.results = this.querySelector('.cg-tl-results');
      this.cards = this.querySelector('.cg-tl-cards');
      this.heading = this.querySelector('.cg-tl-results-title');
      this.map = this.querySelector('.cg-tl-map');
      this.contact = this.querySelector('[data-contact]').href;
      this.mapLocations = [];
      this.requestNumber = 0;
      this.form.addEventListener('submit', event => this.search(event));
      this.input.addEventListener('input', () => {
        this.requestNumber += 1;
        this.input.removeAttribute('aria-invalid');
        this.results.hidden = true;
        this.clearMap();
        this.setStatus(this.copy.initial);
        this.submit.disabled = false;
        this.form.removeAttribute('aria-busy');
      });
      if (this.map) {
        this.map.addEventListener('toggle', () => {
          if (this.map.open) this.renderMap();
        });
        this.map.querySelector('select').addEventListener('change', () => this.renderMap());
      }
      const suppliedZip = new URLSearchParams(window.location.search).get('zip') || '';
      if (/^\d{5}(?:-\d{4})?$/.test(suppliedZip)) {
        this.input.value = suppliedZip.slice(0, 5);
        this.form.requestSubmit();
      }
    }

    setStatus(message, error = false) {
      this.status.textContent = message;
      this.status.dataset.error = String(error);
    }

    element(tag, className, text) {
      const element = document.createElement(tag);
      if (className) element.className = className;
      if (text !== undefined) element.textContent = text;
      return element;
    }

    text(key, values = {}) {
      return this.copy[key].replace(/\{(\w+)\}/g, (_, name) => values[name] ?? '');
    }

    async loadData(zip) {
      const prefix = zip.slice(0, 2);
      if (!this.shardPromises.has(prefix)) {
        const readJson = async url => {
          const response = await fetch(url, { credentials: 'omit', signal: AbortSignal.timeout(20000) });
          if (!response.ok) throw new Error('Data unavailable');
          return response.json();
        };
        if (!this.contactPromise) this.contactPromise = readJson(this.dataset.contactsUrl).catch(error => {
          this.contactPromise = null;
          throw error;
        });
        const promise = Promise.all([readJson(this.zipUrls[prefix]), this.contactPromise]).then(([assignments, contacts]) => {
          if (assignments.schemaVersion !== 1 || contacts.schemaVersion !== 1 || assignments.version !== contacts.version || !assignments.zips || !contacts.terminals) throw new Error('Data versions do not match');
          return { assignments, contacts };
        }).catch(error => {
          this.shardPromises.delete(prefix);
          throw error;
        });
        this.shardPromises.set(prefix, promise);
      }
      return this.shardPromises.get(prefix);
    }

    async search(event) {
      event.preventDefault();
      const request = ++this.requestNumber;
      const value = this.input.value.trim();
      this.results.hidden = true;
      this.clearMap();
      this.form.removeAttribute('aria-busy');
      if (!/^\d{5}(?:-\d{4})?$/.test(value)) {
        this.input.setAttribute('aria-invalid', 'true');
        this.setStatus(this.copy.invalid, true);
        this.input.focus();
        return;
      }
      const zip = value.slice(0, 5);
      this.input.removeAttribute('aria-invalid');
      this.submit.disabled = true;
      this.setStatus(this.copy.loading);
      this.form.setAttribute('aria-busy', 'true');
      try {
        const { assignments, contacts } = await this.loadData(zip);
        if (request !== this.requestNumber || !this.isConnected) return;
        const entry = Object.hasOwn(assignments.zips, zip) ? assignments.zips[zip] : {};
        this.cards.replaceChildren();
        this.mapLocations = [];
        if (['AK', 'HI'].includes(entry.state)) {
          this.setStatus(this.copy.excluded_region);
          return;
        }
        for (const carrier of ['estes', 'tforce']) this.renderCarrier(carrier, entry, contacts.terminals[carrier] || {});
        this.heading.textContent = this.text('results', { zip });
        this.results.hidden = false;
        this.setStatus('');
        this.prepareMap();
        this.heading.focus({ preventScroll: true });
      } catch (error) {
        if (request === this.requestNumber) this.setStatus(this.copy.unavailable, true);
      } finally {
        if (request === this.requestNumber) {
          this.submit.disabled = false;
          this.form.removeAttribute('aria-busy');
        }
      }
    }

    contactLink() {
      const link = this.element('a', '', this.copy.contact);
      link.href = this.contact;
      return link;
    }

    phoneLine(number) {
      const line = this.element('p', 'cg-tl-phone', this.copy.phone + ': ');
      const digits = number.replace(/\D/g, '').replace(/^1(?=\d{10}$)/, '');
      const formatted = digits.length === 10 ? '(' + digits.slice(0, 3) + ') ' + digits.slice(3, 6) + '-' + digits.slice(6) : number;
      const link = this.element('a', '', formatted);
      link.href = 'tel:' + number.replace(/[^+\d]/g, '');
      line.append(link);
      return line;
    }

    formatAddress(address) {
      const cleaned = address.trim().replace(/\s+/g, ' ').replace(/,\s*/g, ', ').replace(/,\s*([A-Z]{2}),?\s+(\d{5}(?:-\d{4})?)$/, ', $1 $2');
      const parts = cleaned.match(/^(.*), ([A-Z]{2}) (\d{5}(?:-\d{4})?)$/);
      if (!parts) return cleaned;
      const streetAndCity = parts[1].replace(/\b[A-Z]{2,}\b/g, word => /^(N|S|E|W|NE|NW|SE|SW|US|PO|FM|RR|SR|IH)$/.test(word) ? word : word[0] + word.slice(1).toLowerCase()).replace(/(\d)(ST|ND|RD|TH)\b/g, (_, digit, suffix) => digit + suffix.toLowerCase());
      return streetAndCity + ', ' + parts[2] + ' ' + parts[3];
    }

    renderCarrier(carrier, entry, terminals) {
      const name = carrier === 'estes' ? 'Estes Express' : 'TForce Freight';
      const card = this.element('article', 'cg-tl-card');
      card.dataset.carrier = carrier;
      card.append(this.element('p', 'cg-tl-carrier', name));
      const assignments = Array.isArray(entry[carrier]) ? entry[carrier] : [];
      if (!assignments.length) {
        const empty = this.element('div', 'cg-tl-terminal');
        empty.append(this.element('h3', '', this.copy.no_assignment), this.element('p', 'cg-tl-missing', this.copy.no_assignment_body), this.contactLink());
        card.append(empty);
      }
      if (assignments.length > 1) card.append(this.element('p', 'cg-tl-note', this.copy.multiple));
      for (const assignment of assignments) {
        const terminal = Object.hasOwn(terminals, assignment.id) ? terminals[assignment.id] : null;
        const statuses = Array.isArray(assignment.statuses) ? assignment.statuses : [];
        const special = ['AK', 'HI', 'PR', 'GU', 'VI'].includes(entry.state) || statuses.length !== 1 || statuses[0] !== 'Direct' || terminal?.requiresConfirmation === true || terminal?.addressVerified === false;
        const confirmation = special || assignments.length > 1 || !terminal;
        const block = this.element('div', 'cg-tl-terminal');
        block.append(this.element('p', 'cg-tl-tag', confirmation ? this.copy.confirmation : this.copy.assignment));
        block.append(this.element('h3', '', terminal?.name || this.text('service_code', { id: assignment.id })));
        if (!terminal?.address || !terminal?.phone || terminal?.addressVerified === false) {
          block.append(this.element('p', 'cg-tl-missing', this.text('missing', { id: assignment.id })));
          if (terminal?.phone) block.append(this.phoneLine(terminal.phone));
          block.append(this.contactLink());
        } else {
          if (special) block.append(this.element('p', 'cg-tl-note', this.copy.special));
          const address = this.element('address', 'cg-tl-address', this.formatAddress(terminal.address));
          block.append(address, this.phoneLine(terminal.phone));
          if (!special) {
            const directions = this.element('a', 'cg-tl-directions', this.copy.directions);
            directions.href = 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(terminal.address);
            directions.target = '_blank';
            directions.rel = 'noopener noreferrer';
            const arrow = this.element('span', '', '→');
            arrow.setAttribute('aria-hidden', 'true');
            directions.append(arrow);
            block.append(directions);
            this.mapLocations.push({ name: name + ' — ' + terminal.name, address: terminal.address });
          } else {
            block.append(this.contactLink());
          }
        }
        card.append(block);
      }
      this.cards.append(card);
    }

    clearMap() {
      if (!this.map) return;
      this.map.open = false;
      this.map.hidden = true;
      this.map.querySelector('.cg-tl-map-frame').replaceChildren();
      this.mapLocations = [];
    }

    prepareMap() {
      if (!this.map || !this.mapLocations.length) return;
      const select = this.map.querySelector('select');
      select.replaceChildren();
      this.mapLocations.forEach((location, index) => {
        const option = this.element('option', '', location.name);
        option.value = String(index);
        select.append(option);
      });
      this.map.hidden = false;
    }

    renderMap() {
      if (!this.map?.open) return;
      const index = Number(this.map.querySelector('select').value);
      const location = this.mapLocations[index];
      if (!location) return;
      const frame = this.element('iframe');
      frame.title = this.text('map_title', { name: location.name });
      frame.loading = 'lazy';
      frame.referrerPolicy = 'no-referrer-when-downgrade';
      frame.setAttribute('allowfullscreen', '');
      frame.src = 'https://maps.google.com/maps?q=' + encodeURIComponent(location.address) + '&z=14&output=embed';
      this.map.querySelector('.cg-tl-map-frame').replaceChildren(frame);
    }
  }
  customElements.define('cg-terminal-locator', CGTerminalLocator);
}


  } catch(e) { console.error(e); }
})();
})();
